<style>

h3{
  text-align: center;
}

</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}

<h3>Change Interests</h3>

<InterestCategories bind:items="{curItems}" on:selected="{selected}"></InterestCategories>

{/if}

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "../../interfaces/Auth.svelte";
let auth;

import Profile from "../../interfaces/Profile.svelte";
let profile;

import Validate from "../../helpers/Validate.js";
import Normalize from "../../helpers/Normalize.js";

import InterestCategories from "../../components/InterestCategories.svelte";
import tinterests from "../../helpers/InterestCategories.js";

export let show = false;
export let me = null;

let curItems = [];
let interests = [];


import { onMount } from "svelte";
onMount(async () => {
  // convert from nested version to flat version for component
  curItems = tinterests.convert();
  set();
});


$:{
  if (me) set();
}


function set() {
  interests = JSON.parse( JSON.stringify( me.interests ) );
  
  // associate selected interests with actual interests in the list
  for (let i in curItems) {
    if (curItems[i].h == 1 && interests.includes(curItems[i].i) == true ) {
      curItems[i].s = true;
    }
  }
  
  curItems = curItems;
}


function selected(e) {
  
  let itemIndex = e.detail.itemIndex;
  let item = e.detail.item;
  // console.log("e.detail.itemIndex:", itemIndex);
  // console.log("e.detail.item:", item);
  
  // if selected, then save it
  if (item.s == false) {
    interests.push(item.i);
    curItems[itemIndex].s = true;
    
    // once we implement paid accounts, we'll enable this code:
    // this makes it so the user can only select 5 interests
    // if (interests.length < 5) {
    //   interests.push(item.i);
    //   curItems[itemIndex].s = true;
    // } else {
    //   freeAccountsShow = true;
    // }
  } else {
    // remove it from the interests array
    curItems[itemIndex].s = false;
    let tindex = interests.indexOf( item.i );
    if (tindex != -1) interests.splice( tindex, 1 );
  }
  
  // console.log("interests:", interests);
  
  check();
    
}


function check() {
  try {
    if (interests.length == 0) throw "Need to select at least one interest";
  } catch (e) {
    console.log("error:", e);
  }
}


export const save = async () => {
  // eventually we'll do a compare here to verify changes...
  // if (interests != me.interests) {
    me.interests = interests;
    await profile.updateMe( { updateShare: true } );
  // }
}


</script>